import React from 'react';
import { useIntl } from 'react-intl';
import css from './CustomBlogPage.module.css';
import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { blogs, dashFormatString, getRefParameter } from './utils';
import { useHistory } from 'react-router-dom';
import MainCard from './components/MainCard/MainCard';
import BigCard from './components/BigCard/BigCard';
import SmallCard from './components/SmallCard/SmallCard';
import BannerSection from './components/BannerSection/BannerSection';

const CustomBlogPage = () => {
  const intl = useIntl();
  const history = useHistory();
  const focusedBlogIndex = getRefParameter();
  const focusedBlog = typeof focusedBlogIndex === 'number' && blogs[focusedBlogIndex];

  const setFocusedBlog = (index, title) =>
    history.push(`/self-build-blogs?ref=${index}&title=${dashFormatString(title)}`);

  const showBlogsList = !focusedBlog?.content;

  const mainBlog = blogs[0];
  const bigCardBlogs = blogs.slice(1, 5);
  const smallCardBlogs = blogs.slice(5);

  return (
    <Page
      title={intl.formatMessage({ id: 'CustomBlogPage.title' })}
      description={intl.formatMessage({ id: 'CustomBlogPage.description' })}
      scrollingDisabled={false}
    >
      <LayoutSingleColumn
        rootClassName={css.pageRoot}
        topbar={<TopbarContainer currentPage="Blogs" type="floating" />}
        footer={<FooterContainer />}
      >
        <div className={css.pageWrapper}>
          {showBlogsList ? (
            <>
              <BannerSection intl={intl} />
              <MainCard
                blog={mainBlog}
                setFocusedBlog={() => setFocusedBlog(0, mainBlog.preview.title)}
              />
              <div className={css.bigCardsWrapper}>
                {bigCardBlogs.map((b, index) => (
                  <BigCard
                    key={index}
                    blog={b}
                    setFocusedBlog={() => setFocusedBlog(index + 1, b.preview.title)}
                    history={history}
                  />
                ))}
              </div>
              <div className={css.cardsWrapper}>
                {smallCardBlogs.map((b, index) => (
                  <SmallCard
                    key={index}
                    blog={b}
                    setFocusedBlog={() => setFocusedBlog(index + 5, b.preview.title)}
                    history={history}
                  />
                ))}
              </div>
            </>
          ) : (
            focusedBlog?.content
          )}
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

export default CustomBlogPage;
